import ContentLayout from "../../components/ContentLayout";
import Faculty from "./FacultyMembers";

const Academic = () => {
  return (
    <ContentLayout children={<Faculty />}/>
  );
};

export default Academic;
